import { Validator } from './Validator';

export const composeValidators = <T>(...validators: Validator<T>[]): Validator<T> => {
  return (value: T | null) => {
    for (const validator of validators) {
      const error = validator(value);
      if (error) return error;
    }
    return undefined;
  };
};

export const required =
  (message: string): Validator<string> =>
  (value) =>
    !value?.trim() ? message : undefined;

export const maxLength =
  (max: number, message: string): Validator<string> =>
  (value) =>
    value && value.length > max ? message : undefined;

export const custom =
  <T>(test: (value: T | null) => boolean, message: string): Validator<T> =>
  (value) =>
    !test(value) ? message : undefined;

export const pattern =
  (regex: RegExp, message: string): Validator<string> =>
  (value) =>
    value && !regex.test(value) ? message : undefined;
